import { TRADE_STATUS } from './types'

export const isInProgress = (status: TRADE_STATUS) =>
  ['approving', 'unbroadcast', 'pending'].includes(status)

export const isSuccess = (status: TRADE_STATUS) => status === 'success'
export const isFailed = (status: TRADE_STATUS) =>
  !isInProgress(status) && !isSuccess(status)
